import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { errorResponseSchema } from '../schemas/common.schemas';
import { marketDemandResponseSchema } from '../schemas/platform-market-intelligence.schemas';

const c = initContract();

export const platformMarketIntelligenceContract = c.router({
  getDemand: {
    method: 'GET',
    path: '/platform/market-intelligence/demand',
    query: z.object({
      city: z.string(),
      market: z.string(),
      category: z.string().optional(),
      from: z.string(),
      to: z.string(),
    }),
    responses: {
      200: marketDemandResponseSchema,
      401: errorResponseSchema,
      404: errorResponseSchema,
      429: errorResponseSchema,
    },
    summary: 'Anonymized aggregate demand signals for B2B partners',
  },
});
